import { Injectable } from '@angular/core'
import { AuthProvider } from '../auth/auth'
import { DeviceType } from '../../models/models'
import { ControlPanelPage } from '../../pages/control-panel/control-panel'
import { CondominiumIntercomPage } from '../../pages/condominium-intercom/condominium-intercom'
import { LoginPage } from '../../pages/login/login'
import { DashboardPage } from '../../pages/dashboard/dashboard'
import { HousingUnitIntercomPage } from '../../pages/housing-unit-intercom/housing-unit-intercom'
import { DeviceProvider } from '../device/device'

/**
Definisce le modalità di funzionamento in base alla configurazione del sistema, in particolare la pagina root
*/
@Injectable()
export class FlavourProvider {
	constructor(
		private auth: AuthProvider,
		private device: DeviceProvider,
	) {
	}

	/**
	restituisce la root attuale, in base allo stato di autenticazione, al dispositivo e alla sua eventuale configurazione
	*/
	public get actualRoot(): any {
		//console.debug('[FlavourProvider.get actualRoot]Recupero la root page attuale..')
		let actualType: DeviceType
		let actual = DeviceProvider.actual
		if(!actual) {
			//console.debug('[FlavourProvider.get actualRoot] Dispositivo senza configurazione', actual)
		} else {
			actualType = actual.type
		}

		if(!actualType) {
			//console.debug('[FlavourProvider.get actualRoot] Tipo non specificato, scelgo tra browser e smartphone..')
			if(this.device.isBrowser) {
				actualType = DeviceType.BROWSER
			} else {
				actualType = DeviceType.SMARTPHONE
			}
		}

		//console.debug('[FlavourProvider.get actualRoot] Tipo del dispositivo da usare:', actualType)

		let root = null
		if(this.auth.isAuth) {
			switch(actualType) {
				case DeviceType.INTERCOM:
				case DeviceType.DASHBOARD:
					root = ControlPanelPage
					break
				default:
				case DeviceType.BROWSER:
				case DeviceType.SMARTPHONE:
					root = ControlPanelPage
					break
			}
		} else {
			switch(actualType) {
				case DeviceType.INTERCOM:
					let condominium = actual.condominium
					if(!condominium) {
						console.warn('Configurazione citofono senza condominio associato', actual)
						root = CondominiumIntercomPage
					} else if(!condominium.housing_units) {
						console.warn('Configurazione citofono senza unità immobiliari nel condominio associato', actual)
						root = CondominiumIntercomPage
					} else if(condominium.housing_units.length == 1) {
						//singola unità abitativa
						root = HousingUnitIntercomPage
					} else {
						root = CondominiumIntercomPage
					}
					break
				case DeviceType.DASHBOARD:
					root = DashboardPage
					break
				default:
				case DeviceType.SMARTPHONE:
				case DeviceType.BROWSER:
					root = LoginPage
					break
				//throw new Error('Autenticazione richiesta per questo tipo di dispositivo: '+this.actualType);
			}
		}
		//console.debug('[FlavourProvider.get actualRoot] Default root da impostare:', root)
		return root
	}
}



// WEBPACK FOOTER //
// ./src/providers/flavour/flavour.ts